<template>
  <div>
    <div class="java110_step">
      <el-steps :active="serviceBindingInfo.index" finish-status="success">
        <el-step title="选择应用"></el-step>
        <el-step title="选择服务"></el-step>
        <el-step title="扩展信息"></el-step>
      </el-steps>
    </div>

    <!-- 选择应用信息 -->
    <div v-if="serviceBindingInfo.index === 0">
      <view-app-info 
        ref="viewAppInfo"
        :call-back-listener="'serviceBinding'" 
        :call-back-function="'notify'"
        :need-show-add-app-button="true"
      ></view-app-info>
    </div>

    <div v-if="serviceBindingInfo.index === 1">
      <view-service-info
        ref="viewServiceInfo"
        :call-back-listener="'serviceBinding'"
        :call-back-function="'notify'"
      ></view-service-info>
    </div>

    <div v-if="serviceBindingInfo.index === 2">
      <add-route-view
        ref="addRouteView"
        :call-back-listener="'serviceBinding'"
        :call-back-function="'notify'"
      ></add-route-view>
    </div>

    <el-row>
      <el-col :span="22" :offset="1">
        <div style="margin-bottom:10px; text-align:right">
          <el-button type="info" @click="_prevStep()">
            {{$t('serviceBinding.prevStep')}}
          </el-button>
          <el-button 
            v-if="serviceBindingInfo.index !== 2" 
            type="primary" 
            style="margin-left:10px;"
            @click="_nextStep()"
          >
            {{$t('serviceBinding.nextStep')}}
          </el-button>
          <el-button 
            v-if="serviceBindingInfo.index === 2" 
            type="primary" 
            style="margin-left:10px;"
            @click="_finishStep()"
          >
            {{$t('serviceBinding.finish')}}
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ViewAppInfo from '@/components/dev/viewAppInfo/viewAppInfo'
import ViewServiceInfo from '@/components/dev/viewServiceInfo/viewServiceInfo'
import AddRouteView from '@/components/dev/addRouteView/addRouteView'
import { bindingService } from '@/api/dev/serviceBindingApi'

export default {
  name: 'ServiceBinding',
  components: {
    ViewAppInfo,
    ViewServiceInfo,
    AddRouteView
  },
  data() {
    return {
      serviceBindingInfo: {
        index: 0,
        infos: []
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.$on("serviceBinding", "notify", (info) => {
        this.serviceBindingInfo.infos[this.serviceBindingInfo.index] = info
      })
    })
  },
  methods: {
    _prevStep() {
      if (this.serviceBindingInfo.index > 0) {
        this.serviceBindingInfo.index--
        this.$refs.viewAppInfo && this.$refs.viewAppInfo.onIndex(this.serviceBindingInfo.index)
        this.$refs.viewServiceInfo && this.$refs.viewServiceInfo.onIndex(this.serviceBindingInfo.index)
        this.$refs.addRouteView && this.$refs.addRouteView.onIndex(this.serviceBindingInfo.index)
      }
    },
    _nextStep() {
      const currentData = this.serviceBindingInfo.infos[this.serviceBindingInfo.index]
      if (!currentData) {
        this.$message.error(this.$t('serviceBinding.pleaseSelectRequired'))
        return
      }
      if (this.serviceBindingInfo.index < 2) {
        this.serviceBindingInfo.index++
        this.$refs.viewAppInfo && this.$refs.viewAppInfo.onIndex(this.serviceBindingInfo.index)
        this.$refs.viewServiceInfo && this.$refs.viewServiceInfo.onIndex(this.serviceBindingInfo.index)
        this.$refs.addRouteView && this.$refs.addRouteView.onIndex(this.serviceBindingInfo.index)
      }
    },
    async _finishStep() {
      const currentData = this.serviceBindingInfo.infos[this.serviceBindingInfo.index]
      if (!currentData) {
        this.$message.error(this.$t('serviceBinding.pleaseSelectRequired'))
        return
      }
      
      try {
        const param = {
          data: this.serviceBindingInfo.infos
        }
        await bindingService(param)
        this.$message.success(this.$t('serviceBinding.processSuccess'))
        this.$router.go(-1)
      } catch (error) {
        this.$message.error(error.message || this.$t('serviceBinding.processFailed'))
      }
    }
  }
}
</script>

<style scoped>
.java110_step {
  margin-bottom: 20px;
}
</style>